import GeniusCarouselTitle from './GeniusCarouselTitle';
import GeniusCarouselWrapper from './GeniusCarouselWrapper';

export default { GeniusCarouselTitle, GeniusCarouselWrapper };
